import React, { useEffect } from 'react';
import { omit } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { getLoading, getSearch, getSorting, getTotal } from './templates-selector';
import { setSearchTemplates, searchTemplates, searchTemplateDrafts, setSortCriterias } from './templates-actions';
import BaseGrid from '../grid/BaseGrid';
import { SearchTemplates } from '../header/search/SearchTemplates';

export const Templates = () => {
  const dispatch = useDispatch();
  const search = useSelector(getSearch);
  const sorting = useSelector(getSorting);
  const total = useSelector(getTotal);
  const loading = useSelector(getLoading);

  // Step 1: Persistent selection state
  const [selected, setSelected] = React.useState<any[]>([]);
  const selectedKeys = selected.map((row) => row.key);

  useEffect(() => {
    // If drafts filter is active, use the drafts-specific search action so the drafts saga runs
    if (search?.drafts) {
      dispatch(searchTemplateDrafts({ ...search, sorting }));
    } else {
      dispatch(searchTemplates({ ...search, sorting }));
    }
  }, [search]);

  const onPageChange = (pageData) => {
    dispatch(setSearchTemplates({ ...search, ...omit(pageData, sorting) }));
    if (pageData.sorting) {
      dispatch(setSortCriterias(pageData.sorting));
    }
  };

  return (
    <>
      <SearchTemplates />
      <BaseGrid
        id='templatesManagement'
        total={total}
        search={search}
        setSearch={onPageChange}
        loading={loading}
        selected={selected}
        setSelected={setSelected}
        selectedKeys={selectedKeys}
        setParentSelected={setSelected}
      />
    </>
  );
};
